import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const commentsAdapter = createEntityAdapter({
  selectId: (comment) => comment._id,
});

const recommendationsAdapter = createEntityAdapter({
  selectId: (recommendation) => recommendation._id,
});

const initialState = {
  ui: {
    loading: false,
    fetching_product: false,
  },
  recipe: {},
  product: {},
  comments: commentsAdapter.getInitialState(),
  recommendations: commentsAdapter.getInitialState(),
  data: [],
};

export const recipeReducerSlice = createSlice({
  name: 'recipe',
  initialState,
  reducers: {
    get_recipe: (state) => {
      state.ui.loading = true;
    },
    get_guest_recipe: (state) => {
      state.ui.loading = true;
    },
    get_guest_recipe_success: (state, { payload }) => {
      state.ui.loading = false;
      state.recipe = Object.assign(state.recipe, payload);
    },
    get_recipe_error: (state) => {
      state.ui.loading = false;
    },
    get_recipe_success: (state, { payload }) => {
      state.ui.loading = false;
      state.ui.fetching_product = true;
      state.recipe = Object.assign(state.recipe, payload);
    },
    get_recipe_product_error: (state) => {
      state.ui.fetching_product = false;
    },
    get_recipe_product_success: (state, { payload }) => {
      state.ui.fetching_product = false;
      state.product = Object.assign(state.product, payload);
    },
    get_comments: (state) => {
      state.ui.loading = true;
    },
    get_comments_error: (state) => {
      state.ui.loading = false;
    },
    get_comments_success: (state, { payload }) => {
      state.ui.loading = false;
      state.comments = commentsAdapter.setAll(state.comments, payload);
    },
    get_recommendations: (state) => {
      state.ui.loading = true;
    },
    get_recommendations_error: (state) => {
      state.ui.loading = false;
    },
    get_recommendations_success: (state, { payload }) => {
      state.ui.loading = false;
      state.recommendations = recommendationsAdapter.setAll(
        state.recommendations,
        payload,
      );
    },
    create_comment: (state) => {
      state.ui.loading = true;
    },
    create_comment_error: (state) => {
      state.ui.loading = false;
    },
    create_comment_success: (state, { payload }) => {
      state.ui.loading = false;
      state.comments = commentsAdapter.addOne(state.comments, payload);
    },
    update_comment: (state) => {
      state.ui.loading = true;
    },
    update_comment_error: (state) => {
      state.ui.loading = false;
    },
    update_comment_success: (state, { payload }) => {
      state.ui.loading = false;
      const data = {
        body: payload.body,
        _id: payload._id,
      };
      state.comments = commentsAdapter.upsertOne(state.comments, data);
    },
    delete_comment: (state) => {
      state.ui.loadComment = true;
    },
    delete_comment_error: (state) => {
      state.ui.loadComment = false;
    },
    delete_comment_success: (state, { payload }) => {
      state.ui.loadComment = true;
      state.comments = commentsAdapter.removeOne(state.comments, payload._id);
    },
    create_reply: (state) => {
      state.ui.loading = true;
    },
    create_reply_error: (state) => {
      state.ui.loading = false;
    },
    create_reply_success: (state, { payload }) => {
      state.ui.loading = false;
      state.comments = commentsAdapter.upsertOne(state.comments, payload);
    },
    update_reply: (state) => {
      state.ui.loading = true;
    },
    update_reply_error: (state) => {
      state.ui.loading = false;
    },
    update_reply_success: (state, { payload }) => {
      state.ui.loading = false;
      state.comments = commentsAdapter.upsertOne(state.comments, payload);
    },
    delete_reply: (state) => {
      state.ui.loading = true;
    },
    delete_reply_error: (state) => {
      state.ui.loading = false;
    },
    delete_reply_success: (state, { payload }) => {
      state.ui.loading = false;
      state.comments = commentsAdapter.upsertOne(state.comments, payload);
    },
  },
});

// Action creators are generated for each case reducer function

export const {
  get_recipe,
  get_guest_recipe,
  get_guest_recipe_success,
  get_recipe_error,
  get_recipe_success,
  get_comments,
  get_comments_error,
  get_comments_success,
  get_recommendations,
  get_recommendations_error,
  get_recommendations_success,
  get_recipe_product_error,
  get_recipe_product_success,
  create_comment,
  create_comment_error,
  create_comment_success,
  create_reply,
  create_reply_error,
  create_reply_success,
  update_reply,
  update_reply_error,
  update_reply_success,
  delete_reply,
  delete_reply_error,
  delete_reply_success,
  delete_comment,
  delete_comment_error,
  delete_comment_success,
  update_comment,
  update_comment_error,
  update_comment_success,
} = recipeReducerSlice.actions;

export default recipeReducerSlice.reducer;
export const commentsSelector = commentsAdapter.getSelectors();
export const recommendationsSelector = recommendationsAdapter.getSelectors();
